export default __webpack_public_path__ + "static/media/grid2.cc040158.jpg";